export const publistColumns = [{
    title: '序号',
    dataIndex: 'id',
    align: 'center',
    width: 100,
    slots: {
      title: '序号'
    },
    scopedSlots: {
      customRender: 'id'
    }
  },
  {
    title: '封面期刊',
    dataIndex: 'cover',
    width: 200,
    align: 'left',
    slots: {
      title: '封面期刊'
    },
    scopedSlots: {
      customRender: 'cover'
    }
  },
  // {
  //   title: '书背',
  //   dataIndex: 'background_cover',
  //   align: 'left',
  //   slots: {
  //     title: '封面期刊'
  //   },
  //   scopedSlots: {
  //     customRender: 'background_cover'
  //   }
  // },
  {
    title: '期刊标题',
    dataIndex: 'title',
    width: 300,
    align: 'left'
  },
  {
    title: '期刊年份',
    dataIndex: 'year',
    width: 120,
    align: 'center',
    slots: {
      title: '封面期刊'
    },
  },
  {
    title: '发布时间',
    dataIndex: 'issue_time',
    align: 'left',
    scopedSlots: {
      customRender: 'issue_time'
    }
  },
  {
    title: '编辑时间',
    dataIndex: 'created_at',
    align: 'left',
    scopedSlots: {
      customRender: 'created_at'
    }
  },
  {
    title: '状态',
    dataIndex: 'issue',
    align: 'left',
    slots: {
      title: '状态'
    },
    scopedSlots: {
      customRender: 'issue'
    }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    align: 'center',
    slots: {
      title: '操作'
    },
    scopedSlots: {
      customRender: 'operate'
    }
  },
]
export const nextColumns = [{
    title: '序号',
    dataIndex: 'id',
    align: 'center'
  },
  {
    title: '预告封面',
    dataIndex: 'cover',
    align: 'left',
    slots: {
      title: '预告封面'
    },
    scopedSlots: {
      customRender: 'cover'
    }
  },
  {
    title: '预告说明',
    dataIndex: 'remark',
    align: 'left'
  },
  {
    title: '预告时间',
    dataIndex: 'activity_start',
    align: 'left',
    slots: {
      title: '预告时间'
    },
    scopedSlots: {
      customRender: 'activity_start'
    }
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    slots: {
      title: '状态'
    },
    scopedSlots: {
      customRender: 'status'
    }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    align: 'center',
    slots: {
      title: '操作'
    },
    scopedSlots: {
      customRender: 'operate'
    }
  },
]
export const newPublishRules = {
  issue_time: [{
    required: true,
    message: '请选择发布时间',
    trigger: 'change'
  }],
  title: [{
    required: true,
    message: '请输入期刊标题,长度不超过24个字符',
    trigger: 'change',
    max: 24
  }],
  year: [{
    required: true,
    message: '请选择期刊年份',
    trigger: 'change',
  }],
  subtitle: [{
    required: true,
    message: '请输入期刊内容,长度不超过64个字符',
    trigger: 'change',
    max: 64
  }],
}
export const newNextRules = {
  time: [{
    required: true,
    message: '请选择发布时间',
    trigger: 'change'
  }],
  remark: [{
    required: true,
    message: '请输入预告说明',
    trigger: 'change'
  }],
}
export const journalYear = [
  {
    value: '2010',
    label: '2010'
  }, {
    value: '2011',
    label: '2011'
  }, {
    value: '2012',
    label: '2012'
  }, {
    value: '2013',
    label: '2013'
  }, {
    value: '2014',
    label: '2014'
  }, {
    value: '2015',
    label: '2015'
  }, {
    value: '2016',
    label: '2016'
  }, {
    value: '2017',
    label: '2017'
  }, {
    value: '2018',
    label: '2018'
  }, {
    value: '2019',
    label: '2019'
  }, {
    value: '2020',
    label: '2020'
  }, {
    value: '2021',
    label: '2021'
  }, {
    value: '2022',
    label: '2022'
  }, {
    value: '2023',
    label: '2023'
  }, {
    value: '2024',
    label: '2024'
  }, {
    value: '2025',
    label: '2025'
  }, {
    value: '2026',
    label: '2026'
  }, {
    value: '2027',
    label: '2027'
  }, {
    value: '2028',
    label: '2028'
  }, {
    value: '2029',
    label: '2029'
  }, {
    value: '2030',
    label: '2030'
  }
]
